import { Selector, State, StateContext } from '@ngxs/store';
import { Receiver, EmitterAction } from '@ngxs-labs/emitter';
import { EventEntry, ReminderEntry } from '../@models/index';
import { Injectable, Injector } from '@angular/core';
import { FeedService } from '../@services/index';

export interface RemindersStateModel {
  entries: ReminderEntry[];
  loading: boolean;
}

@State<RemindersStateModel>({
  name: 'reminders',
  defaults: {
    entries: [],
    loading: false
  }
})
@Injectable()
export class RemindersState {

  private static feedService: FeedService

  @Selector()
  static getAll(state: RemindersStateModel): ReminderEntry[] {
    return state?.entries || [];
  }

  @Selector()
  static isLoading(state: RemindersStateModel): boolean {
    return !!state?.loading;
  }

  constructor(injector: Injector) {
    RemindersState.feedService = injector.get(FeedService);
  }

  @Receiver()
  static loadAll({ patchState }: StateContext<RemindersStateModel>) {
    const startDate: string = new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString();
    const endDate: string = new Date().toISOString();

    patchState({ loading: true });

    this.feedService.getReminders(startDate, endDate).subscribe(
      (reminders: ReminderEntry[]) => {
        patchState({
          entries: reminders || [],
          loading: false
        });
      },
      () => {
        patchState({ loading: false });
      }
    );
  }

}
